const isError = function(e) {
  try {
    return e instanceof Error;
  } catch (err) {}

  return (
    e &&
    e.stack &&
    e.message &&
    typeof e.stack === "string" &&
    typeof e.message === "string"
  );
};

export default isError;
